import { useEffect, useState } from "react";

const NotificationModal = () => {
    const [dontShowModalAgain, setDontShowModalAgain] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const storageKey = "hideWelcomeModal";

    useEffect(() => {
        const showModalUntilDate = new Date("2026-09-15");
        const now = new Date();
        const isExpired = now > showModalUntilDate;
        const isDismissed = localStorage.getItem(storageKey) === "true";

        if (!isExpired && !isDismissed) {
            setOpenModal(true);
        }
    }, []);

    const handleClose = () => {
        if (dontShowModalAgain) {
            localStorage.setItem(storageKey, "true")
        }
        setOpenModal(false);
    }

    if (!openModal) return null;

    return (

        <div className="fixed inset-0 z-50 flex items-center justify-center">

            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50"
                onClick={handleClose}
            />

            {/* Modal */}
            <div className="relative bg-white! rounded-xl shadow-lg w-full! max-w-xl! p-6! z-10">

                {/* Header */}
                <div className="flex justify-between items-center mb-2">
                    <h2 className="!text-xl !font-semibold">
                        Logistikportalen har fått nytt utseende!                    
                    </h2>
                </div>

                {/* Body */}
                <div className="mb-6">
                    <p className="text-gray-600">
                        
                        Välkommen till den nya versionen av Logistikportalen.
                        Vi hoppas du kommer uppleva denna version av Logistikportalen tydligare och lättare att använda.
                        <br/>
                        <br/>
                        <b>I logistikportalen hittar du följande:</b>
                        <ul className="list-none pl-0 space-y-1">
                            <li>- Vägledningar & riktlinjer</li>
                            <li>- IT-verktyg & produktionsstöd</li>
                            <li>- Utbildningar</li>
                            <li>- Kompetensnätverk</li>
                            <li>- Försvarslogistik</li>
                            <li>- FMV PLM</li>
                            <li>- ILS</li>
                        </ul>
                        Lämna gärna feedback på Logistikportalens utseende, struktur och innehåll via knappen till höger på sidan på den interna delen av logistikportalen.
                        <br />
                        <br />
                        För att komma till den interna delen av logistikportalen kan du trycka på knappen "interna startsidan" med ett lås framför som du hittar i det gröna menyfältet på denna sida.
                    </p>
                </div>

                {/* Footer */}
                <div className="flex justify-between items-center">
                    <label className="!flex !items-center !gap-2 !text-sm">
                        <input
                            type="checkbox"
                            className="w-4 h-4"
                            checked={dontShowModalAgain}
                            onChange={(e) =>
                                setDontShowModalAgain(e.target.checked)
                            }
                        />
                        Visa inte detta meddelande igen
                    </label>

                    <button
                        onClick={handleClose}
                        className="bg-[#007167] !text-white !px-4 !py-2 !rounded-lg hover:!opacity-90 !w-[100px]"
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    )
}

export default NotificationModal;